import zod from 'zod';
import { stringToBoolean, zodLimit, zodPage } from './helpers';
import { CitizenStatus } from '../services/central-api/citizen';

const CitizenManagementSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    status: zod.nativeEnum(CitizenStatus).optional(),
    createdAt: zod.coerce.number().optional(),
});

const CitizenLprEventsSchema = zod.object({});

const CitizenLprSearchSchema = zod.object({
    plate: zod.string().optional(),
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    irregularSituation: stringToBoolean.optional(),
});

const CitizenBlockReasonsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional()
});

const CitizenLprDetectionDetailsSchema = zod.object({
    id: zod.coerce.number(),
});

export const CitizenSchemas = {
    CitizenManagement: CitizenManagementSchema,
    CitizenLprEvents: CitizenLprEventsSchema,
    CitizenLprSearch: CitizenLprSearchSchema,
    CitizenLprEventsDetails: CitizenLprDetectionDetailsSchema,
    CitizenBlockReasons: CitizenBlockReasonsSchema,
};
